import { render, staticRenderFns } from "./InsightsDefault.vue?vue&type=template&id=25366cbf&"
import script from "./InsightsDefault.vue?vue&type=script&lang=js&"
export * from "./InsightsDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports